<script setup lang="ts">
interface Props {
  backLinkLabel: string
  backLinkUrl: string
  description: string
  title: string
}

defineProps<Props>()
</script>

<template>
  <section class="error-message">
    <Wrapper>
      <div class="error-message__content">
        <UIDynamicHeading v-if="title">
          {{ title }}
        </UIDynamicHeading>
        <p v-if="description">
          {{ description }}
        </p>
        <UIButton
          :href="backLinkUrl"
          variant="primary"
        >
          {{ backLinkLabel }}
        </UIButton>
      </div>
    </Wrapper>
  </section>
</template>

<style lang="scss" scoped>
  .error-message {
    @apply py-[100px] text-center;

    &__content {
      @apply flex flex-col items-center gap-[30px];
    }

    p {
      @apply text-[18px] text-primary m-0;
      @apply xl:text-[24px];
    }
  }
</style>
